import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TokenListFullNameHeaderProps
  extends HeaderContext<GatewayTokenModel, GatewayTokenModel['firstName']> {}

export const TokenListFullNameHeader =
  (): // props: TokenListFullNameHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return `${t('delmonicos-shared-sdk.outputs-token.first-name')} - ${t('delmonicos-shared-sdk.outputs-token.last-name')}`;
  };
